const catalogue3 = (data) => {
  const node = data.node;
  const catalogueList = node.list;
  const color = data.color;
  let htmlText = '<ul style="">';
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += ` <li><p style=\"\"><strong><span style=\"font-size: 27.34375px;\"><span style=\"font-family: Microsoft Yahei;\"><span style=\"color: #2C3F55;\">${item}</span></span></span></strong></p></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "ihVsjnsujK",
        width: 220,
        height: 562,
        left: 0,
        top: 0.6666666666666666,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "pf3k1_AgNr",
        width: 419.7380249343832,
        height: 419.8188156167979,
        left: 462.4509514435695,
        top: 64.64476706036746,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: htmlText,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "3sKlRvEMPC",
        width: 157.44996719160105,
        height: 157.44996719160105,
        left: 141.27501640419948,
        top: 202.94168307086613,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        outline: { width: 2, color: "#ffffff", style: "solid" },
      },
      {
        type: "text",
        id: "iPyKIOFDmc",
        width: 207.65001640419948,
        height: 70.5,
        left: 116.17503280839895,
        top: 239.66166338582676,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><span style="color: #FFFFFF;font-size: 63.28125px;font-family: Microsoft Yahei;">目录</span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],
    background: { type: "solid", color: "#EFFFFD" },
  };
};

export default catalogue3;
